import axios from 'axios';
import { SERVER_ENDPOINT, CLIENT_ID, CLIENT_SECRET } from '../../Constants';

function addProductToCart(token, productUrl) {
  const url = 'api/basket/add-product/';
  return axios({
    method: 'post',
    url,
    baseURL: SERVER_ENDPOINT,
    timeout: '10000',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      authorization: 'Bearer ' + token,
    },
    data: {
      client_id: CLIENT_ID,
      client_secret: CLIENT_SECRET,
      url: productUrl,
      quantity: 1,
    },
  });
}

function getCart(token) {
  const url = 'api/basket/';
  return axios({
    method: 'get',
    url,
    baseURL: SERVER_ENDPOINT,
    timeout: '10000',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      authorization: 'Bearer ' + token,
    },
    data: {
      client_id: CLIENT_ID,
      client_secret: CLIENT_SECRET,
    },
  });
}

function getLines(token, endpoint) {
  // we must manually change http to https!
  const split = endpoint.split('/');
  let newend = SERVER_ENDPOINT + '/api';
  split.forEach((s, i) => {
    if (i > 3) {
      newend += '/';
      newend += s;
    }
  });
  const url = '';
  return axios({
    method: 'get',
    url,
    baseURL: newend,
    timeout: '10000',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      authorization: 'Bearer ' + token,
    },
    data: {
      client_id: CLIENT_ID,
      client_secret: CLIENT_SECRET,
    },
  });
}

function getLine(token, endpoint) {
  // we must manually change http to https!
  const split = endpoint.split('/');
  let newend = SERVER_ENDPOINT + '/api';
  split.forEach((s, i) => {
    if (i > 3) {
      newend += '/';
      newend += s;
    }
  });
  const url = '';
  return axios({
    method: 'get',
    url,
    baseURL: newend,
    timeout: '10000',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      authorization: 'Bearer ' + token,
    },
    data: {
      client_id: CLIENT_ID,
      client_secret: CLIENT_SECRET,
    },
  });
}

function removeProductFromCart(token, endpoint) {
  // we must manually change http to https!
  const split = endpoint.split('/');
  let newend = SERVER_ENDPOINT + '/api';
  split.forEach((s, i) => {
    if (i > 3) {
      newend += '/';
      newend += s;
    }
  });
  const url = '';
  return axios({
    method: 'delete',
    url,
    baseURL: newend,
    timeout: '10000',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      authorization: 'Bearer ' + token,
    },
    data: {
      client_id: CLIENT_ID,
      client_secret: CLIENT_SECRET,
    },
  });
}

function updateQuantity(token, quantity, endpoint) {
  // we must manually change http to https!
  const split = endpoint.split('/');
  let newend = SERVER_ENDPOINT + '/api';
  split.forEach((s, i) => {
    if (i > 3) {
      newend += '/';
      newend += s;
    }
  });
  const url = '';
  return axios({
    method: 'put',
    url,
    baseURL: newend,
    timeout: '10000',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      authorization: 'Bearer ' + token,
    },
    data: {
      client_id: CLIENT_ID,
      client_secret: CLIENT_SECRET,
      quantity,
    },
  });
}

function updateCartDiscount(token, discountCode, basketID) {
  const url = 'api/basket/add-voucher/';
  return axios({
    method: 'post',
    url,
    baseURL: SERVER_ENDPOINT,
    timeout: '10000',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      authorization: 'Bearer ' + token,
    },
    data: {
      client_id: CLIENT_ID,
      client_secret: CLIENT_SECRET,
      vouchercode: discountCode,
    },
  });
}


export {
  addProductToCart,
  getCart,
  getLines,
  getLine,
  removeProductFromCart,
  updateQuantity,
  updateCartDiscount,
};
